import { createContext, useState, useEffect } from "react";

export const ClassContext = createContext();

export const ClassProvider = ({ children }) => {
  const [selectedClassId, setSelectedClassId] = useState(() => {
    return JSON.parse(sessionStorage.getItem("selectedClassId")) ?? null;
  });

  const [selectedBreakoutRoom, setSelectedBreakoutRoom] = useState(() => {
    return JSON.parse(sessionStorage.getItem("selectedBreakoutRoom")) ?? null;
  });

  const [tutorSelectedClassId, setTutorSelectedClassId] = useState(() => {
    return JSON.parse(sessionStorage.getItem("tutorSelectedClassId")) ?? null;
  });

  const [tutorSelectedBreakoutRoom, setTutorSelectedBreakoutRoom] = useState(
    () => {
      return (
        JSON.parse(sessionStorage.getItem("tutorSelectedBreakoutRoom")) ?? null
      );
    }
  );

  useEffect(() => {
    sessionStorage.setItem("selectedClassId", JSON.stringify(selectedClassId));
  }, [selectedClassId]);

  useEffect(() => {
    sessionStorage.setItem(
      "selectedBreakoutRoom",
      JSON.stringify(selectedBreakoutRoom)
    );
  }, [selectedBreakoutRoom]);

  useEffect(() => {
    sessionStorage.setItem(
      "tutorSelectedClassId",
      JSON.stringify(tutorSelectedClassId)
    );
  }, [tutorSelectedClassId]);

  useEffect(() => {
    sessionStorage.setItem(
      "tutorSelectedBreakoutRoom",
      JSON.stringify(tutorSelectedBreakoutRoom)
    );
  }, [tutorSelectedBreakoutRoom]);

  return (
    <ClassContext.Provider
      value={{
        selectedClassId,
        setSelectedClassId,
        selectedBreakoutRoom,
        setSelectedBreakoutRoom,
        tutorSelectedClassId,
        setTutorSelectedClassId,
        tutorSelectedBreakoutRoom,
        setTutorSelectedBreakoutRoom,
      }}
    >
      {children}
    </ClassContext.Provider>
  );
};
